import { mdiFileDocumentOutline } from '@mdi/js'
import { NameCellWrapper, NameIcon } from './styles'

interface NameCellProps {
  name: string
}

function NameCell({ name }: NameCellProps) {
  return (
    <NameCellWrapper>
      <NameIcon path={mdiFileDocumentOutline} />
      {name}
    </NameCellWrapper>
  )
}

export default NameCell
